/**
 * 运行状态和设备状态
 */
export default {
  // runstate
  RUNSTATE_NORMAL: 1, // 正常
  RUNSTATE_FIX: 2, // 维护
  RUNSTATE_FAULT: 3, // 故障
  RUNSTATE_COLLECT: 4, // 采集基线

  // 观测器状态
  POINT_STATE_UNCONNECT: -1, // 未连接
  POINT_STATE_CONNECT: 0, // 正常
  POINT_STATE_WARN: 1, // 预警
  POINT_STATE_DANGER: 2, // 报警
  POINT_STATE_HIGH_RISK: 3, // 高危
  POINT_STATE_FIX: 61, // 维护
  POINT_STATE_FAULT: 71, // 故障
  POINT_STATE_COLLECT: 81, // 采集基线
  POINT_STATE_GREEN: 200 // 此状态没有任何设备意义，仅仅为了将文字或者背景渲染为绿色
};
